import { useEffect } from 'react';
import useDeck from '../hooks/use-deck';
export var Notes = function Notes(props) {
  var context = useDeck();
  useEffect(function () {
    context.register(context.index, 'notes', props.children);
  }, [props.children]);
  return false;
};
export default Notes;